// /src/core/login.ts

import { isLocalHost } from "./http";

export function loginStayOnPage(): void {
    const returnUrl = window.location.href;
    const loginUrl = `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(returnUrl)}`;
    if (isLocalHost(window.location.hostname)) return;
    window.location.replace(loginUrl);
}

export function openLoginPopup(): Window | null {
    if (isLocalHost(window.location.hostname)) return null;

    const popupReturn = `${window.location.origin}/pages/errors/login-popup.html`;
    const loginUrl = `/.auth/login/aad?post_login_redirect_uri=${encodeURIComponent(popupReturn)}`;

    const features = [
        "width=520",
        "height=720",
        "left=100",
        "top=80",
        "resizable=yes",
        "scrollbars=yes",
    ].join(",");

    return window.open(loginUrl, "context_auth_popup", features);
}

